import { z } from 'zod'

export const ApiToken = z.object({
  id: z.number(),
  name: z.string(),
  created: z.string(),
  last_used: z.string().nullish(),
  active: z.boolean()
})

export const ApiTokenCreateRequest = z.object({
  name: z.string()
})

export const ApiTokenUpdateRequest = z.object({
  active: z.boolean()
})

export const ApiTokenCreateResponse = z.object({
  token: z.string(),
  info: ApiToken
})

export type ApiToken = z.infer<typeof ApiToken>
export type ApiTokenCreateRequest = z.infer<typeof ApiTokenCreateRequest>
export type ApiTokenUpdateRequest = z.infer<typeof ApiTokenUpdateRequest>
export type ApiTokenCreateResponse = z.infer<typeof ApiTokenCreateResponse>
